/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * List of all agreed games for this schedule
 */
export type AgreedGameDto = {
    /**
     * Preseason game ID
     */
    preseasonGameId?: number;
    /**
     * Preseason game status
     */
    status?: AgreedGameDto.status;
    /**
     * Agreed date in ISO8601 format (yyyy-MM-dd)
     */
    agreedDate?: string;
    /**
     * Agreed start time in ISO8601 format (HH:mm:ss)
     */
    agreedStartTime?: string;
    /**
     * Agreed end time in ISO8601 format (HH:mm:ss)
     */
    agreedEndTime?: string;
    /**
     * Proposed new date from date change proposal
     */
    proposedDate?: string;
    /**
     * Proposed start time from date/time proposal
     */
    proposedStartTime?: string;
    /**
     * Proposed end time from date/time proposal
     */
    proposedEndTime?: string;
    /**
     * True if the proposal was created by the querying team
     */
    isOwnProposal?: boolean;
    /**
     * Opponent team ID
     */
    opponentTeamId?: number;
    /**
     * Opponent team name
     */
    opponentTeamName?: string;
    /**
     * Opponent team tier
     */
    opponentTier?: string;
    /**
     * Opponent sports club logo URL
     */
    logoUrl?: string;
    /**
     * Pitch location if available
     */
    location?: string;
    /**
     * Proposed location from date/time proposal
     */
    proposedLocation?: string;
    /**
     * Whether the opponent is a manual entry (not registered in the system)
     */
    isManualOpponent?: boolean;
    /**
     * Name of the manual opponent
     */
    manualOpponentName?: string;
};
export namespace AgreedGameDto {
    /**
     * Preseason game status
     */
    export enum status {
        PENDING = 'PENDING',
        PENDING_DATE_TIME_PROPOSAL = 'PENDING_DATE_TIME_PROPOSAL',
        PENDING_CHANGE_DATE = 'PENDING_CHANGE_DATE',
        APPROVED = 'APPROVED',
        APPROVED_WITH_TIME_TO_CONFIRM = 'APPROVED_WITH_TIME_TO_CONFIRM',
        REJECTED = 'REJECTED',
        CANCELLED = 'CANCELLED',
    }
}

